import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { LockKeyhole } from 'lucide-react';

export default function LoginPage({ useAuth }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!auth.loading && auth.user) return <Navigate to="/dashboard" replace />;

  async function submit(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await auth.login(email, password, remember);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login-layout">
      <form className="login-panel" onSubmit={submit}>
        <div className="login-title">
          <span className="login-icon">
            <LockKeyhole size={22} />
          </span>
          <div>
            <h1>Source Manager</h1>
            <p>Redaktions-Dashboard</p>
          </div>
        </div>
        {error ? <div className="alert">{error}</div> : null}
        <label>
          Email
          <input value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" type="email" required />
        </label>
        <label>
          Passwort
          <input
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            type="password"
            required
          />
        </label>
        <label className="check-row">
          <input checked={remember} onChange={(event) => setRemember(event.target.checked)} type="checkbox" />
          <span>30 Tage merken</span>
        </label>
        <button className="primary-button" disabled={submitting} type="submit">
          {submitting ? 'Anmelden...' : 'Login'}
        </button>
        <footer>Version 2.0</footer>
      </form>
    </main>
  );
}
